import React from 'react'
import ClassName from 'classnames'
import { Button } from 'components'
import styles from './Selector.module.scss'

const Selector = ({
  active,
  onClick,
  options,
  className = '',
  tabbed = false,
  buttonClass = '',
}) => {
  return (
    <div className={ClassName(styles.selectorContainer, className)}>
      <div className={ClassName(styles.wrapper, tabbed && styles.tabs)}>
        {options.map(({ name, label }) => (
          <Button
            key={name}
            type="filled"
            onClick={() => onClick(name)}
            className={ClassName(
              buttonClass,
              styles.button,
              !active[name] && styles.disabled
            )}
            fontSize="xsmall"
          >
            <p>{label}</p>
          </Button>
        ))}
      </div>
    </div>
  )
}

export default React.memo(Selector)
